import ActivityIntervention from './activityIntervention.js';
export default ActivityIntervention;
